import { POST } from './api';

/**
 * Envia uma mensagem ao personagem, passando pelo NOSSO servidor.
 *
 * Antes, cada tela de conversa chamava o n8n direto, com o endereço escrito
 * dentro do código do site (que é público). Agora o site só conhece
 * POST /api/chat — o servidor é quem sabe para onde encaminhar, e só atende
 * quem está logado.
 *
 * @param {Object} p
 * @param {string} p.personagem - 'salomao' | 'daniel' | 'ester' | 'davi'
 * @param {string} p.modo       - 'chat' (Bate-papo) | 'learn' (Praticar Idiomas)
 * @param {string} p.query      - a mensagem do usuário
 * @param {string} p.conversationId - id da conversa (para o personagem lembrar)
 * @returns {Promise<{conversation_id: string, answer: string}>}
 * @throws {Error} se o servidor não responder ou recusar
 */
export const SendChatMessage = async ({ personagem, modo, query, conversationId }) => {
    const resposta = await POST('/chat', {
        personagem,
        modo,
        query,
        conversation_id: conversationId || null,
    }, true); // true = envia o crachá de quem está logado

    // ServerFetch devolve false quando a rede falha
    if (!resposta) {
        throw new Error('Sem resposta do servidor.');
    }
    // O Strapi devolve { error: {...} } quando recusa
    if (resposta.error) {
        throw new Error(resposta.error.message || 'O assistente recusou o pedido.');
    }
    if (typeof resposta.answer !== 'string') {
        throw new Error('Resposta em formato inesperado.');
    }

    return resposta;
};
